import React from 'react'
import { createRoot } from 'react-dom/client'
// import '../stylesheets/application-vite.scss'
// @ts-expect-error
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.js'
import 'trix'
import '@rails/actiontext'
import '../banners'
import '../chatbot-tracking'
import '../chatbot/mount'
import '../charts'
import { CalculatorApp } from '../calculator/javascript/calculator'

const initialize = () => {
  ;(window as any).Tooltip = Tooltip

  // Admin-only explanation dialogs on the dashboard: clicking a
  // `.admin-explain-trigger` with `data-dialog-target="<id>"` opens the
  // matching <dialog> as a modal. Delegated so it works even if nodes are
  // added dynamically.
  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement | null
    const trigger = target?.closest<HTMLElement>('[data-dialog-target]')
    if (!trigger) return
    const dialogId = trigger.getAttribute('data-dialog-target')
    if (!dialogId) return
    const dialog = document.getElementById(dialogId) as HTMLDialogElement | null
    if (dialog && typeof dialog.showModal === 'function') {
      event.preventDefault()
      dialog.showModal()
    }
  })

  const container = document.querySelector('[data-calculator-root]')
  if (!container) return

  const root = createRoot(container) // createRoot(container!) if you use TypeScript
  root.render(<CalculatorApp />)
}

initialize()
